import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";


const routes: Routes = [
  {
    path: "htmlToArticle",
    loadChildren: () => import("./html-to-article/html-to-article.module").then(file => file.HtmlToArticleModule)
  },

  {
    path: "publishedLocales",
    loadChildren: () => import("./published-locales/published-locales.module").then(file => file.PublishedLocalesModule)
  },

  {
    path: "preview",
    loadChildren: () => import("./previewing/previewing.module")
      .then(file => file.PreviewingModule)
  },

  {
    path: "softwareSelection",
    loadChildren: () => import("./software-selection/software-selection.module")
      .then(file => file.SoftwareSelectionModule)
  },

  {
    path: "categorySelection",
    loadChildren: () => import("./category-selection/category-selection.module")
      .then(file => file.CategorySelectionModule)
  },

  {
    path: "related-software",
    loadChildren: () => import("./related-software/related-software.module")
      .then(file => file.RelatedSoftwareModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
